import React, { Children, Fragment, PropsWithChildren } from 'react'
import cn from 'clsx'
import { rem } from 'polished'
import styled from 'styled-components'
import Divider from 'components/Luxkit/Divider'
import { mediaQueryUp } from 'components/utils/breakpoint'

const PricingBlocks = styled.div`
  display: grid;
  gap: ${rem(12)};
  grid-template-rows: 1fr;
  grid-auto-flow: column;

  &.cols-1 {
    grid-auto-columns: 1fr;

    ${mediaQueryUp.tablet} {
      width: ${rem(250)};
    }
  }

  &.cols-2 {
    grid-auto-columns: minmax(0, 1fr) 1px minmax(0, 1fr);

    ${mediaQueryUp.tablet} {
      width: ${rem(364)};
    }

    ${mediaQueryUp.desktop} {
      width: ${rem(380)};
    }
  }
`

function AccommodationPackageTilePricingBlocks(props: PropsWithChildren) {
  const { children } = props

  const childrenArray = Children.toArray(children)
  const cols = childrenArray.length

  return <PricingBlocks className={cn(`cols-${cols}`)}>
    {childrenArray.map((child, index) => <Fragment key={index}>
      {index !== 0 && <Divider kind="primary" direction="vertical" />}
      {child}
    </Fragment>)}
  </PricingBlocks>
}

export default AccommodationPackageTilePricingBlocks
